
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  place-self-stretch:stretch;
  display:block;
  height:100%;
  overflow:hidden;
}

.video-modal{
  height:100%;
}

.video-modal > *{
    height:100%;
  }

button.trigger{
  position:relative;
  width:100%;
  height:100%;
  cursor:pointer;
  padding:0;
  border:0;
  outline-offset:2px;
}

button.trigger:hover .play-overlay .btn{
    transform:scale(1.05);
  }

button.trigger:focus .play-overlay .btn, button.trigger:focus-within .play-overlay .btn{
    background-color:var(--outline-button--primary-bg-color-focus--computed);
    color:var(--outline-button--primary-color-focus--computed);
    font-weight:var(--outline-button--primary-weight-focus--computed);
    outline:2px solid var(--outline-button-accent-color);
    outline-offset:2px;
  }

.play-overlay{
  position:absolute;
  z-index:5;
  inset:0;
  display:flex;
  align-items:center;
  justify-content:center;
  width:100%;
  height:100%;
  cursor:pointer;
}

.play-overlay.is-open{
    display:none;
  }

.video-wrapper{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  overflow:hidden;
}

.video-image{
  width:100%;
}

.video-wrapper,
.video-image,
img,
[slot='video-image']{
  height:100%;
}

.video-wrapper > div, .video-image > div, img > div, [slot='video-image'] > div{
    height:100%;
  }

img{
  aspect-ratio:4 / 3;
  width:100%;
  max-width:100%;
  max-height:100%;
  object-fit:cover;
}

.modal{
  z-index:2;
  position:fixed;
  inset:0;
  background-color:rgba(0, 0, 0, 0.8);
}

.modal-container{
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  width:100vw;
  height:100vh;
  padding:1rem;
}

.modal-content{
  display:flex;
  position:relative;
  flex-direction:column;
  flex-flow:column nowrap;
  flex-wrap:nowrap;
  align-items:stretch;
  justify-content:space-evenly;
  overflow:hidden;
  padding:var(--spacing-4);
}

.modal-content .close{
    position:absolute;
    top:2px;
    right:2px;
    transition-duration:0.2s;
    z-index:9;
  }

.video{
  display:flex;
  justify-content:center;
  align-items:center;
  width:100%;
  height:100%;
}

.accessibility-description{
  position:absolute;
  width:1px;
  height:1px;
  padding:0;
  margin:-1px;
  overflow:hidden;
  clip:rect(0, 0, 0, 0);
  white-space:nowrap;
  border-width:0;
}

.video-summary{
  font-size:0.875rem;
  line-height:150%;
  font-family:var(--ff-body);
}
`;